$(function () {
	var $element = $('.signup');
	var phone = $element.find('#phone_number');
	var email = $element.find("#email_address");
	var form = $element.find('#newsletter_signup');
	var submit = $element.find('#form_submit');
	var error_txt = $element.find('#ShowerrorMsg');
	var success_msg = $element.find('#success');
	var consent_box = $element.find('#consent_box');

	//use intersection observer to add visible class on $element
	var observer = new IntersectionObserver(function(entries) {
		if (entries[0].isIntersecting === true) {
			$element.find("form").slideDown(1000)
			$element.addClass('visible')
		}
	}
	, { threshold: [0], rootMargin: "0px 0px -30% 0px" });

	observer.observe($element[0]);

	phone.hide();

	function validateEmail(email_address){
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email_address);
	}

	submit.click(function(e){
		e.preventDefault()
		if (!validateEmail(email.val()) ) {
			email.attr('class','validation_error')
			error_txt.text('Please enter a valid Email.');
			return;
		} else {
			email.removeClass('validation_error');
		}
		if (!consent_box.is(':checked')){
			return;
		}
		if (form.find('.validation_error').length) {
			return;
		} else {
			$('.validation_error').removeClass('validation_error');
		}
		var data = {};

		data.phone_number = phone.val();
		form.addClass('submitting');
		$.post('/wp-json/3fo/utilities/spam-check', data, function(response) {
			if (response.success) {
				phone.remove();

				var data = {
					"PostData": {
						"emailAddress": email.val(),
					}
				};

				$.ajax({
					type: "POST",
					url: response.url,
					contentType: "application/json",
					crossDomain: true,
					dataType: "json",
					data: JSON.stringify(data)
				}).done(function(result) {
					if (result !== null) {
						if (result.Status == 'Success') {
							form.hide();
							success_msg.show();
						}
					}
				}).fail(function(XMLHttpRequest, textStatus, errorThrown) {
					error_txt.text('Something went wrong with the form submission');
					console.log("Request: " + XMLHttpRequest.toString() + "\n\nStatus: " + textStatus + "\n\nError: " + errorThrown);
				});
			} else {
				form.removeClass('submitting');
			}
		})
	});
});

